'use es6';

import PropTypes from 'prop-types';
export default PropTypes.shape({
  all: PropTypes.func.isRequired,
  byId: PropTypes.func.isRequired
});